<!--  -->
<template>
  <div class="appeal-main">
    <div class="title">申述</div>
    <h-form ref="formRefs" :model="formItem" :label-width="138" style="padding-bottom: 96px;" :rules="ruleCustom">
      <h-form-item label="简述问题" required prop="title">
        <h-input v-model.trim="formItem.title" placeholder="请简要概括您想要申述的内容" :maxlength="50"></h-input>
      </h-form-item>
      <h-form-item label="详细描述" required prop="content">
        <h-input v-model.trim="formItem.content" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请具体详细描述"
          :maxlength="500" showWordLimit></h-input>
      </h-form-item>
      <h-form-item label="联系人" required prop="contactName">
        <h-input v-model.trim="formItem.contactName" placeholder="请输入您的姓名" :maxlength="50"></h-input>
      </h-form-item>
      <h-form-item label="手机/邮箱" required prop="contactInfo">
        <h-input v-model.trim="formItem.contactInfo" placeholder="请输入正确的手机或邮箱，我们将通过该方式反馈处理结果"></h-input>
      </h-form-item>
      <h-form-item label="">
        <div class="captcha-box">
          <h-input v-model="captchaCode" placeholder="请输入右侧的图形验证码"></h-input>
          <img id="JPGCode" class="message-div" :src="JPGCodeUrl" @click="initCaptcha">
        </div>
      </h-form-item>

      <h-form-item prop="chkcode" label="验证码">
        <h-input v-model="formItem.chkcode" type="text" placeholder="请输入验证码" autocomplete="off" special-filter
          :special-decimal="0" :special-length="6" />
        <div class="message-div" :class="{
    'secondes-message': checkCodeActive && !resendShow && captchaCode && formItem.contactInfo
  }" @click="submitCode">
          {{ !resendShow ? "发送验证码" : `${qrSeconds}秒后可重发` }}
        </div>
      </h-form-item>
      <h-form-item label="上传附件" prop="file" cols="2">
        <upload-item ref="uploadItem" name="上传附件" :type="fileType" :fileMax="fileMax"
          :fileMaxTip="fileMaxTip"></upload-item>
        <p class="tip">
          选择文件，允许文件类型:png、jpg、jpeg、pdf，不超过2M
        </p>
      </h-form-item>
      <h-form-item>
        <h-button type="primary" @click="ok" :disabled="btnState || btnState1">提交</h-button>
      </h-form-item>
    </h-form>
  </div>
</template>

<script>
  import { getCamelCase } from "@/utils";
  import { mapGetters } from "vuex";
  import UploadItem from "@/views/frontViews/uploadItem";
  import {
    submitWorkOrder
  } from "@/api/submitWorkOrderApi/submitWorkOrder.js";
  import {
    getCaptcha,
    checkCaptcha,
    getChkCode,
    checkChkCode
  } from "@/api/uPlusApi/index.js";
  import {validMobile,validateEmail} from '@/utils/validate'
  import _ from "lodash";
  import axios from "axios";
  // import { getUrlParam } from "@/utils";

  export default {
    components: {
      UploadItem
    },
    data() {
      const phoneOrEmailRule = (rule, value, callback) => {
        if (value) {
          if (
            !validMobile(value)&&!validateEmail(value)
          ) {
            this.checkCodeActive = false;
            // 不合法
            return callback(new Error("请输入正确的手机号码或邮箱"));
          }
        }

        this.checkCodeActive = true;
        console.log(this.checkCodeActive)
        return callback();
      };
      return {
        showCaptcha: false,
        captchaId: '',
        JPGCodeUrl: '',
        resendShow: false,
        captchaCode: '',
        qrSeconds: 60,
        timer: null,
        checkCodeActive: false,
        successShow: false,
        chkcodeToken:'',
        
        formItem: {
          title: "",
          content: "",
          contactName: "",
          contactInfo: "",
          chkcode: "",//验证码
        },
        btnState1: false,
        ruleCustom: {
          contactInfo: [{ validator: phoneOrEmailRule, trigger: "blur" }]
        },
        fileType: ['png', 'jpg', 'jpeg', 'pdf'],
        fileMax: 1024 * 1024 * 2,
        fileMaxTip: '附件大小不能超过2M'
      };
    },
    computed: {
      ...mapGetters(["user", "loginInfo"]),
      // 表单填写完整时登录按钮变蓝
      btnState() {
        //当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
        if (
          !(
            this.formItem.title &&
            this.formItem.title !== "" &&
            this.formItem.content &&
            this.formItem.content !== "" &&
            this.formItem.contactName &&
            this.formItem.contactName !== "" &&
            this.formItem.contactInfo &&
            this.formItem.contactInfo !== "" &&
            this.formItem.chkcode &&
            this.formItem.chkcode !== ""
          )
        )
          return true;
        else return false;
      }
    },
    created() {
    },
    mounted() {
      this.initCaptcha()
    },
    watch: {
    },
    methods: {
      async initCaptcha() {
        const {error_info,error_no,result} = await getCaptcha({
          option_type: '11'
        })
        if (error_no=='0') {
          if (result.show_captcha == '0') {
            this.showCaptcha = false
            this.captchaId = result.captcha_id
          } else {
            this.captchaId = result.captcha_id
            this.JPGCodeUrl = result.captcha_image
            this.showCaptcha = true
            this.captchaCode = ""
          }
        }else{
          this.$hMessage.error(error_info)
        }
      },
      resendMessage() {
        this.resendShow = true;
        this.timer = null;
        this.qrSeconds = 60;
        this.timer = setInterval(() => {
          if (this.qrSeconds == 0) {
            this.resendShow = false;
            clearInterval(this.timer);
            return;
          }
          this.qrSeconds--;
        }, 1000);
      },
      // 校验图形验证码
      async submitCode() {
        if (this.captchaCode === '') {
          this.$hMessage.error('请输入图形验证码')
          return
        }
        let params = {
          captcha_id: this.captchaId,
          captcha_code: this.captchaCode
        }
        const {error_info,error_no,result} = await checkCaptcha(params)
        if (error_no=='0') {
            this.captchaToken = result.captcha_token;
            this.getCode()
      }else{
        this.initCaptcha()
          this.$hMessage.error(error_info)
        }
      },
      sendMsg() {
        this.submitCode()
      },
      // 获取验证码
      async getCode() {
        let email = ''
        let mobileTel = ''
        if (this.formItem.contactInfo.indexOf('@') == -1) {
          mobileTel = this.formItem.contactInfo
        } else {
          email = this.formItem.contactInfo
        }
        let params = {
          authmsg_busi_type: 10,
          captcha_token: this.showCaptcha ? this.captchaToken : this.captchaId,
          email: email,
          mobile_tel: mobileTel
        }
        const {error_info,error_no,result} = await getChkCode(params)
        if (error_no=='0') {
          this.$hMessage.success('验证码已发送，请耐心等候')
            clearInterval(this.timer);
            this.resendMessage();
            this.chkcodeKey = result.chkcode_key
        }else{
          this.$hMessage.error(error_info)
        }
      },
      // 校验验证码
      checkChechCode() {
        return new Promise((resolve, reject) => {
          if (this.formItem.chkcode === '') {
            this.$hMessage.error('请输入验证码')
            reject()
          } else {
            let params = {
              auth_check_code: this.formItem.chkcode,
              chkcode_key: this.chkcodeKey
            }
            checkChkCode(params).then(res => {
              const {error_info,error_no,result} = res 
              debugger
              if (error_no =='0') {
                this.chkcodeToken = result.chkcode_token;
                resolve()
              } else {
                this.$hMessage.error(error_info)
                reject()
              }
            }).catch(err => {
              console.log(err)
              reject()
            })
          }
        });

      },



      ok() {
        let that = this;

        that.$refs.formRefs.validate(valid => {
          if (valid) {
            this.checkChechCode().then(() => {
              let formData = new FormData();
              let list = that.$refs.uploadItem.inputImgIlist;
              for (var i = 0; i < list.length; i++) {
                formData.append("file", list[i]);
              }
              for (let key in that.formItem) {
                formData.append(getCamelCase(key), that.formItem[key]);
              }
              formData.append("chkcodeToken", this.chkcodeToken);

              this.btnState1 = true;
              axios({
                url:
                  "/openplat-gateway/openplat/openplat-service-server/v/feedback/submitWorkOrder",
                data: formData,
                method: "post",
                headers: {
                  "content-type": "multipart/form-data",
                  "Access-Token":
                    sessionStorage.getItem("Access-Token") ||
                    localStorage.getItem("Access-Token")
                },
                withCredentials: true
              })
                .then(res => {
                  this.btnState1 = false;
                  if (res.data.error_code && res.data.error_code !== "0") {
                    that.$hMessage.error(res.data.error_info, 3000);
                  } else {
                    let data = res.data.data;
                    that.$refs.formRefs.resetFields();
                    that.successShow = true;
                    that.$router.push("/workOrder/submitAppealSuccess?feed_back_id="+data.feed_back_id);
                  }
                })
                .catch(error => {
                  this.btnState1 = false;
                });
            })

          } else this.btnState1 = false;
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
  .submitWorkOrder-bg {
    background: url("~@/assets/submitWorkOrder/banner-1920.png") no-repeat top center;

    .appeal-main {
      margin: auto;

      &>.title {
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        padding: 90px 0;
        letter-spacing: 4px;
        margin: 0;
      }

      .kj-box {
        display: flex;
        width: 100%;
        margin-top: -18px;
        margin-bottom: 16px;

        &>.title {
          width: 138px;
          text-align: right;
          padding-right: 16px;
          color: #999;
          line-height: 26px;
        }

        &>ul {
          display: flex;
          flex-wrap: wrap;
          width: 540px;
          text-align: center;

          li {
            width: 24%;
            margin-right: 7px;
            background: rgba(48, 96, 255, 0.08);
            border: 1px solid #3060ff;
            color: #3060ff;
            margin-bottom: 8px;
            cursor: pointer;
            padding: 2px 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .select {
            color: #fff;
            background: #3060ff;
          }

          li:nth-of-type(4n) {
            margin-right: 0;
          }
        }
      }

      .workOrder-box {
        width: 170px;
        border: 1px solid #d9d9d9;
        padding: 10px 16px;
        margin-right: 16px;

        &:hover {
          cursor: pointer;
        }

        p {
          font-size: 12px;
          color: #999999;
          line-height: 18px;
          padding-left: 25px;
        }
      }

      .selected {
        border: 1px solid #3060ff;
        background: #fff;
        box-shadow: 11px 11px 25px 0px rgba(0, 0, 0, 0.13);
      }

      .tip {
        font-size: 12px;
        color: #999999;
        letter-spacing: 1px;
        line-height: 18px;
        margin-top: 8px;
      }
    }
  }
</style>
<style lang="scss">
  .appeal-main {
    text-align: center;

    .message-div {
      position: absolute;
      top: 0;
      right: 0;
      background: #e2e2e2;
      border: 1px solid #e2e2e2;
      width: 120px;
      height: 36px;
      border-radius: 0 6px 6px 0;
      text-align: center;
      font-family: PingFangSC-Regular;
      color: #ffffff;
      line-height: 36px;
      cursor: not-allowed;
      z-index: 2;
    }

    .secondes-message {
      background: #3060ff;
      border: 1px solid #3060ff;
      cursor: pointer;

    }

    .captcha-box {
      position: relative;
    }

    .h-form {
      display: inline-block;
      text-align: left;

      .h-form-item {
        margin-bottom: 20px;

        .h-form-item-content {
          width: 540px;

          .h-input {
            border-radius: 2px;
            height: 36px;
            padding: 5px 16px;
            font-size: 14px;
          }

          .h-select-selection {
            border-radius: 2px;
            height: 36px;

            .icon-unfold:before {
              background-color: rgb(217, 217, 217);
              color: #fff;
            }

            .h-select-arrow {
              font-size: 20px;
              line-height: 16px;
              right: 12px;
            }

            .h-select-placeholder,
            .h-select-selected-value {
              font-size: 14px;
              height: 36px;
              line-height: 36px;
              padding-left: 16px;
            }
          }

          .h-select-dropdown {
            border-radius: 2px;

            .h-select-item {
              font-size: 14px;
            }
          }
        }
      }

      &>.h-form-item:nth-last-child(2) {
        margin-bottom: 40px;
      }

      .h-btn {
        border-radius: 2px;
        width: 152px;
        height: 36px;
        line-height: 22px;
      }

      .h-form-item-label {
        padding-right: 16px;
        font-size: 14px;
        font-weight: 600;
      }

      .h-form-item-label {
        line-height: 36px;
      }


      .h-radio-group {
        display: flex;
        justify-content: flex-start;

        .h-radio-wrapper {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/gtn/views/frontViews/submitAppeal.vue